export interface IPersonType {
  id: number;
  name: string | null;
  active: boolean;
  displayOrder: number | null;
}

export class PersonType implements IPersonType {
  id;
  name;
  active;
  displayOrder;

  constructor(config: IPersonType) {
    this.id = config.id;
    this.name = config.name || null;
    this.active = config.active;
    this.displayOrder = config.displayOrder || null;
  }
}
